import { create } from 'zustand';

interface SquadTvModeState {
  isActive: boolean;
  groupId: string | null;
  enterTvMode: (groupId: string) => void;
  exitTvMode: () => void;
}

export const useSquadTvModeStore = create<SquadTvModeState>((set) => ({
  isActive: false,
  groupId: null,
  enterTvMode: (groupId) => set({ isActive: true, groupId }),
  exitTvMode: () => set({ isActive: false, groupId: null }),
}));
